export default __webpack_public_path__ + "static/media/mongodb.3beac5ba.svg";